import React from 'react'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { helpRouteProps } from 'src/navigation/routeProps'

const HelpAppRoute: AppRoute = {
  routeProps: helpRouteProps,
  component: <div>{'I am Help'}</div>,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default HelpAppRoute
